import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Popover, { PopoverHeader, PopoverBody } from 'components/ui/popover';
import { v4 as uuidv4 } from 'uuid';
import isNil from 'lodash/isNil';
import 'fonts/icons/scss/nucleo.scss';
import './icon.scss';

const Icon = ({ name, className, tooltip, size, ...otherProps }) => {
  const [iconId, setIconId] = useState(uuidv4());
  const id = `icon_${iconId}`;

  return (
    <>
      <i
        id={id}
        className={classNames(`icon icon-${name}`, {
          [className]: !!className,
        })}
        {...otherProps}
      />
      {!isNil(tooltip) && (
        <Popover target={id} trigger="hover" placement={tooltip.placement || 'top'}>
          {tooltip.title && <PopoverHeader>{tooltip.title}</PopoverHeader>}
          {tooltip.content && <PopoverBody>{tooltip.content}</PopoverBody>}
          {tooltip.contentHTML && (
            <PopoverBody>
              <span dangerouslySetInnerHTML={{ __html: tooltip.contentHTML }} />
            </PopoverBody>
          )}
        </Popover>
      )}
    </>
  );
};

Icon.defaultProps = {
  className: null,
  tooltip: null,
};

Icon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  tooltip: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
    placement: PropTypes.string,
  }),
};

export default Icon;
